// extracted by mini-css-extract-plugin
export default {"overlayModule":"DragOverlayModule_overlayModule__U15yJ","moduleName":"DragOverlayModule_moduleName__KajBt","moduleVersion":"DragOverlayModule_moduleVersion__xo6Bi"};